const arrowHandler = (prev, sign, totalPage, pagesPerList) => {
  const nextIndex = prev.end + pagesPerList;
  let result;
  if (sign === 1) {
    result = nextIndex > totalPage ? totalPage : nextIndex;
  } else if (sign === -1) {
    result =
      prev.end - prev.start < pagesPerList - 1
        ? prev.start - 1
        : prev.end - pagesPerList;
  }
  return { ...prev, start: prev.start + pagesPerList * sign, end: result };
};

export default arrowHandler;
